module.exports = __webpack_public_path__ + "static/img/44.245e704.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/gwphoto/44.jpg
// module id = Vp84
// module chunks = 1